import { render } from "./CreateHospitalisation.vue?vue&type=template&id=5370064e&scoped=true"
import script from "./CreateHospitalisation.vue?vue&type=script&lang=js"
export * from "./CreateHospitalisation.vue?vue&type=script&lang=js"

import "./CreateHospitalisation.vue?vue&type=style&index=0&id=5370064e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5370064e"]])

export default __exports__